import { AppThemeDefinition } from './app-theme.model';

export const DEFAULT_APP_THEME_ID = 'progescode-admin';

export const APP_THEMES: AppThemeDefinition[] = [
    {
    id: 'progescode-admin',
    label: 'ProgesCode admin',
    colorScheme: 'light',
    atomicColorTheme: 'blue',
    tokens: {
      /*colorPrimary: '#0057F2',
      colorSecondary: '#00A19E',
      colorAccent: '#0d8d6b',
      colorBackground: '#FAFBFF',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#1C2E52',
      colorTextSecondary: '#7B93C7',
      colorSuccess: '#00A19E',
      colorWarning: '#FE8A02',
      colorError: '#f4611d',*/
      
      colorPrimary: '#3B82F6',
      colorSecondary: '#14B8A6',
      colorAccent: '#E2E8F0',
      colorBackground: '#F8FAFC',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#111827',
      colorTextSecondary: '#4B5563',
      colorSuccess: '#22C55E',
      colorWarning: '#F59E0B',
      colorError: '#EF4444',
    },
  },
 
  {
    id: 'dark-green-lemon',
    label: 'Dark Green Lemon',
    colorScheme: 'dark',
    atomicColorTheme: 'teal',
    tokens: {
      colorPrimary: '#B8F32A',
      colorSecondary: '#4ADE80',
      colorAccent: '#1F3324',
      colorBackground: '#070D08',
      colorSurface: '#0E1710',
      colorTextPrimary: '#E8F5E3',
      colorTextSecondary: '#93AC98',
      colorSuccess: '#4ADE80',
      colorWarning: '#FACC15',
      colorError: '#F87171',
    },
  },
     {
    id: 'progescode-admin-dark',
    label: 'ProgesCode admin dark',
    colorScheme: 'dark',
    atomicColorTheme: 'blue',
    tokens: {
      colorPrimary: '#5AA9FF',
      colorSecondary: '#7AD0FF',
      colorAccent: '#1F3324',
      colorBackground: '#070D08',
      colorSurface: '#0E1710',
      colorTextPrimary: '#E8F5E3',
      colorTextSecondary: '#93AC98',
      colorSuccess: '#7AD0FF',
      colorWarning: '#FACC15',
      colorError: '#F87171',
    },
  },
  {
    id: 'corporate-blue',
    label: 'Corporate Blue',
    colorScheme: 'light',
    atomicColorTheme: 'blue',
    tokens: {
      colorPrimary: '#3B82F6',
      colorSecondary: '#14B8A6',
      colorAccent: '#E2E8F0',
      colorBackground: '#F8FAFC',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#111827',
      colorTextSecondary: '#4B5563',
      colorSuccess: '#22C55E',
      colorWarning: '#F59E0B',
      colorError: '#EF4444',
    },
  },
  {
    id: 'corporate-blue-dark',
    label: 'Corporate Blue Dark',
    colorScheme: 'dark',
    atomicColorTheme: 'blue',
    tokens: {
      colorPrimary: '#60A5FA',
      colorSecondary: '#2DD4BF',
      colorAccent: '#334155',
      colorBackground: '#0F172A',
      colorSurface: '#1E293B',
      colorTextPrimary: '#F1F5F9',
      colorTextSecondary: '#CBD5E1',
      colorSuccess: '#4ADE80',
      colorWarning: '#FBBF24',
      colorError: '#F87171',
    },
  },
  {
    id: 'terracotta-dune',
    label: 'Terracotta Dune',
    colorScheme: 'light',
    atomicColorTheme: 'pink',
    tokens: {
      colorPrimary: '#B67332',
      colorSecondary: '#DAAB3A',
      colorAccent: '#E5E7E6',
      colorBackground: '#FAF6EF',
      colorSurface: '#FFFDF8',
      colorTextPrimary: '#3E2A1C',
      colorTextSecondary: '#7A5B45',
      colorSuccess: '#7AA95C',
      colorWarning: '#DAAB3A',
      colorError: '#A7001E',
    },
  },
  {
    id: 'blush-lagoon',
    label: 'Blush Lagoon',
    colorScheme: 'light',
    atomicColorTheme: 'pink',
    tokens: {
      colorPrimary: '#CA3C66',
      colorSecondary: '#4AA3A2',
      colorAccent: '#E8AABE',
      colorBackground: '#FFF6FA',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#3B1E2A',
      colorTextSecondary: '#6B5A63',
      colorSuccess: '#4AA3A2',
      colorWarning: '#DB6A8F',
      colorError: '#A62E52',
    },
  },
  {
    id: 'canyon-breeze',
    label: 'Canyon Breeze',
    colorScheme: 'light',
    atomicColorTheme: 'teal',
    tokens: {
      colorPrimary: '#D46F4D',
      colorSecondary: '#08C5D1',
      colorAccent: '#FFBF66',
      colorBackground: '#FFF8F5',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#3F241C',
      colorTextSecondary: '#6A5A54',
      colorSuccess: '#2AAE9F',
      colorWarning: '#FFBF66',
      colorError: '#B2442F',
    },
  },
  {
    id: 'vintage-atlantic',
    label: 'Vintage Atlantic',
    colorScheme: 'light',
    atomicColorTheme: 'blue',
    tokens: {
      colorPrimary: '#4A919E',
      colorSecondary: '#212E53',
      colorAccent: '#BED3C3',
      colorBackground: '#F6FBF9',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#1F2A3A',
      colorTextSecondary: '#5A6875',
      colorSuccess: '#4A919E',
      colorWarning: '#CE6A6B',
      colorError: '#8C2F40',
    },
  },
  {
    id: 'cotton-candy-sky',
    label: 'Cotton Candy Sky',
    colorScheme: 'light',
    atomicColorTheme: 'blue',
    tokens: {
      colorPrimary: '#5784BA',
      colorSecondary: '#9AC8EB',
      colorAccent: '#F4CFDF',
      colorBackground: '#FCFCF7',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#23344F',
      colorTextSecondary: '#5D6E86',
      colorSuccess: '#7BBFA3',
      colorWarning: '#DAAB3A',
      colorError: '#C95A72',
    },
  },
  {
    id: 'coral-mint',
    label: 'Coral Mint',
    colorScheme: 'light',
    atomicColorTheme: 'teal',
    tokens: {
      colorPrimary: '#F27438',
      colorSecondary: '#2CCED2',
      colorAccent: '#76CDCD',
      colorBackground: '#FFF9F6',
      colorSurface: '#FFFFFF',
      colorTextPrimary: '#2C3940',
      colorTextSecondary: '#5C6E74',
      colorSuccess: '#2CCED2',
      colorWarning: '#F9968B',
      colorError: '#CC5130',
    },
  },
  {
    id: 'noir-crimson',
    label: 'Noir Crimson',
    colorScheme: 'dark',
    atomicColorTheme: 'pink',
    tokens: {
      colorPrimary: '#A7001E',
      colorSecondary: '#7AA95C',
      colorAccent: '#955149',
      colorBackground: '#1E0F1C',
      colorSurface: '#2A1627',
      colorTextPrimary: '#F6EAF1',
      colorTextSecondary: '#CBB8C4',
      colorSuccess: '#7AA95C',
      colorWarning: '#E2A93B',
      colorError: '#D23A52',
    },
  },
  {
    id: 'abyss-cyan',
    label: 'Abyss Cyan',
    colorScheme: 'dark',
    atomicColorTheme: 'teal',
    tokens: {
      colorPrimary: '#08C5D1',
      colorSecondary: '#D46F4D',
      colorAccent: '#FFBF66',
      colorBackground: '#00353F',
      colorSurface: '#0B4652',
      colorTextPrimary: '#E9FAFC',
      colorTextSecondary: '#B1D7DC',
      colorSuccess: '#32D39A',
      colorWarning: '#FFBF66',
      colorError: '#F26D5E',
    },
  },


];